import React, { FC } from 'react';
import classnames from 'classnames';

import { withTheme } from '@glu/theming';
import Alert, { AlertVariant } from '@glu/alerts-react';

import useLocale from 'components/useLocale';

import { ALERTVARIATIONS, DEFAULT_PROPS } from 'constants.js';
import useStyles from './Alert.styles';

const { EMPTY_FUNCTION } = DEFAULT_PROPS;

interface Props {
  children?: React.ReactNode;
  dataQa?: string | null;
  details?: boolean;
  dismissible?: boolean;
  errorGuid?: string;
  msg?: string;
  onHide?: () => void;
  suppressIcon?: boolean;
  title?: string;
  variant: AlertVariant;
}

const AlertComponent: FC<Props> = ({
  children = null,
  dataQa = null,
  details = false,
  dismissible = true,
  errorGuid = '',
  msg = '',
  onHide = EMPTY_FUNCTION,
  suppressIcon = false,
  title = '',
  variant = ALERTVARIATIONS.INFO as AlertVariant
}) => {
  const locale = useLocale();
  const { alert, guidMsg, message } = useStyles();

  return (
    <Alert
      className={alert}
      dataQa={dataQa ? `${dataQa}-${variant}-alert` : `${variant}-alert`}
      dismissible={dismissible}
      message={
        <>
          {msg || null}
          <div className={classnames({ [message]: details })}>{children}</div>
          {errorGuid && (
            <div className={guidMsg}>
              <span>
                {locale['common.referenceNumber']} - {errorGuid}
              </span>
            </div>
          )}
        </>
      }
      onHide={onHide}
      suppressIcon={suppressIcon}
      title={title}
      variant={variant}
    />
  );
};

export default withTheme(AlertComponent);
